import * as React from "react";
import styled from "styled-components";
import { Card, Colors, Overlay, Spinner } from "@blueprintjs/core";
import { useDatatable2Context } from "../DataTable2";

export interface ILoadingOverlayProps {
  overlayWidth: number;
  overlayHeight: number;
}

const CustomCard = styled(Card)`
  padding: 0.5rem;
  border-radius: 10px;
`;

const StyledOverlayContent = styled.div`
  display: flex;
  justify-content: center;
  width: 100%auto;
  flex: 1;
  align-items: flex-start;
  margin-top: 100px;
  &:focus {
    outline: none;
  }
`;

export const LoadingOverlay: React.FunctionComponent<ILoadingOverlayProps> = ({
  overlayWidth,
  overlayHeight,
}) => {
  const { translateFunc, loading, customLoadingComponent } =
    useDatatable2Context();

  return (
    <Overlay isOpen={loading} hasBackdrop={false} usePortal={false}>
      <StyledOverlayContent
        style={{
          width: overlayWidth,
          height: overlayHeight,
        }}
      >
        {customLoadingComponent || (
          <CustomCard elevation={4}>
            <Spinner size={24}></Spinner>
            <span style={{ color: Colors.BLACK }}>
              {translateFunc("GeneralLoading")}
            </span>
          </CustomCard>
        )}
      </StyledOverlayContent>
    </Overlay>
  );
};
